import React from "react";
import styles from "./Trends.module.css";

export type InsightsGranularity = "week" | "month";

export interface PeriodSelectorProps {
  insightsGranularity: InsightsGranularity;
  setInsightsGranularity: (g: InsightsGranularity) => void;
  availableWeeks: Array<{ key: string; label: string }>;
  selectedWeek: string;
  onWeekChange: (weekKey: string) => void;
  availableMonths: Array<{ key: string; label: string }>;
  selectedMonth: string;
  onMonthChange: (monthKey: string) => void;
}

export default function PeriodSelector({
  insightsGranularity,
  setInsightsGranularity,
  availableWeeks,
  selectedWeek,
  onWeekChange,
  availableMonths,
  selectedMonth,
  onMonthChange,
}: PeriodSelectorProps) {
  return (
    <div className={styles["insights-period-selector-row"]}>
      <div
        className={styles["insights-granularity-segments"]}
        role="tablist"
        aria-label="Period range"
      >
        <button
          type="button"
          role="tab"
          aria-selected={insightsGranularity === "month"}
          className={[
            styles["insights-granularity-segment"],
            insightsGranularity === "month" &&
              styles["insights-granularity-segment-active"],
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => setInsightsGranularity("month")}
        >
          Month
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={insightsGranularity === "week"}
          className={[
            styles["insights-granularity-segment"],
            insightsGranularity === "week" &&
              styles["insights-granularity-segment-active"],
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => setInsightsGranularity("week")}
        >
          Week
        </button>
      </div>

      available weeks
      {insightsGranularity === "week" && availableWeeks.length > 0 && (
        <select
          value={selectedWeek}
          onChange={(e) => onWeekChange(e.target.value)}
          className={styles["insights-period-select"]}
          aria-label="Select week"
        >
          {availableWeeks.map((week) => (
            <option key={week.key} value={week.key}>
              {week.label}
            </option>
          ))}
        </select>
      )}

      {insightsGranularity === "month" && availableMonths.length > 0 && (
        <select
          value={selectedMonth}
          onChange={(e) => onMonthChange(e.target.value)}
          className={styles["insights-period-select"]}
          aria-label="Select month"
        >
          {availableMonths.map((m) => (
            <option key={m.key} value={m.key}>
              {m.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
